<!-- MOLECULE: FooterLinks.vue -->

<script setup lang="ts">
//
// ============================================================================
// TYPES
// ============================================================================
//

interface FooterLink {
  text: string;
  href: string;
  icon?: string;
  external?: boolean;
  tooltip?: string;
}

//
// ============================================================================
// PROPS
// ============================================================================
//

interface Props {
  title: string;
  links: FooterLink[];
}

defineProps<Props>();
</script>

<template>
  <div>
    <h4 class="text-subtitle-2 font-weight-medium mb-4 mt-1 text-uppercase">
      {{ title }}
    </h4>

    <div class="d-flex flex-column ga-2">
      <v-hover v-for="link in links" :key="link.text" v-slot="{ isHovering, props: hoverProps }">
        <a
          v-tooltip:top="{
            text: link.tooltip || link.text,
            openDelay: 500,
            closeDelay: 200,
          }"
          v-bind="hoverProps"
          :href="link.href"
          :target="link.external ? '_blank' : undefined"
          :rel="link.external ? 'noopener' : undefined"
          class="text-body-2 text-decoration-none d-inline-flex align-center text-on-surface"
          :style="{ width: 'fit-content', color: 'inherit' }"
        >
          <v-icon
            v-if="link.icon"
            :icon="link.icon"
            size="small"
            class="me-2"
            :class="{ 'text-primary': isHovering }"
          />
          <span
            :class="[{ 'text-primary': isHovering }, { 'text-decoration-underline': isHovering }]"
          >
            {{ link.text }}
          </span>
        </a>
      </v-hover>
    </div>
  </div>
</template>
